/**
 * @method setCookie
 * @description Method that sets a cookie
 * @param {string} cookieName Cookie's name to use in cookies string
 * @param {string} cookieValue Cookie's value to use in cookies string
 * @param {number} expirationDays Cookie's expiration date in days
 */
export function setCookie(cookieName, cookieValue, expirationDays) {
  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + expirationDays * 24 * 60 * 60 * 1000);
  const expiresString = `expires=${expirationDate.toUTCString()}`;
  document.cookie = `${cookieName}=${cookieValue}; ${expiresString}; domain=directvgo.com; secure; HttpOnly; path=/`;
}

/**
 * @method getCookie
 * @description Method that gets a cookie
 * @param {string} cookieName Cookie's name in the cookies string
 */
function getCookie(cookieName) {
  const cookieNameString = `${cookieName}=`;
  const decodedCookies = decodeURIComponent(document.cookie);
  const decodedCookiesSplitted = decodedCookies.split(";");
  for (let i = 0; i < decodedCookiesSplitted.length; i += 1) {
    let cookie = decodedCookiesSplitted[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieNameString) === 0) {
      return cookie.substring(cookieNameString.length, cookie.length);
    }
  }
  return "";
}

/**
 * @method checkCookie
 * @description Method that returns true if the cookie exist in the cookie string
 * @param {string} cookieName Cookie's name in the cookies string
 */
export function checkCookie(cookieName) {
  return getCookie(cookieName) !== "";
}
